import { useQuery } from "@tanstack/react-query";
import { trpc, useTRPC } from "../../../shared/api/trpc";

export type PublicBoardView = Awaited<ReturnType<typeof trpc.viewShares.read.query>>;

// Anonymous access to a shared read-only view: the capability token is the
// whole authorization, no session involved.
export function usePublicView(token: string) {
  const trpcClient = useTRPC();
  const viewQuery = useQuery(trpcClient.viewShares.read.queryOptions({ token }, { retry: false }));

  return {
    data: viewQuery.data ?? null,
    isError: viewQuery.isError,
    isPending: viewQuery.isPending,
  };
}
